import { DataTableController } from "./controller.interface";
import { FlowDataTableComponent } from "../flow-data-table.component";

export class DefaultController implements DataTableController<any> {
    component: FlowDataTableComponent;

    onInit(): void {
    }

    objectEquals(obj1: any, obj2: any): boolean {
        //return obj1 === obj2; //too simple; need to verify matching based on if all Object.entries properties match
        if (obj1 === undefined || obj1 === null) return false;
        if (obj2 === undefined || obj2 === null) return false;
        const sortedObj1 = Object.entries(obj1).sort((a, b) => b[0].localeCompare(a[0]));
        const sortedObj2 = Object.entries(obj2).sort((a, b) => b[0].localeCompare(a[0]));
        let keyMatched: boolean = false;
        let matches: boolean = true;
        for (let [key1, value1] of sortedObj1) {
            for (let [key2, value2] of sortedObj2) {
                if (key1 === key2) {
                    keyMatched = true;
                    matches = value1 === value2;                    
                }     
                if (!matches) break;
            }
            if (!keyMatched || !matches) break;
        }
        return keyMatched && matches;
    }


}
